module.exports = __webpack_public_path__ + "static/media/restaurant10.020981ce.jpg";